import { useCallback, useEffect, useState } from 'react';
import { listMaintenanceTasks } from '@/modules/maintenance/services/maintenanceRepository';
import type { MaintenanceTask } from '@/modules/maintenance/types/maintenance';

export function useMaintenanceTasks() {
  const [tasks, setTasks] = useState<MaintenanceTask[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  const reload = useCallback(async () => {
    setLoading(true);
    setError(null);
    try {
      const data = await listMaintenanceTasks();
      setTasks(data);
    } catch {
      setError('No se pudieron cargar las tareas de mantenimiento.');
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    void reload();
  }, [reload]);

  return { tasks, loading, error, reload };
}
